import { render, staticRenderFns } from "./dwv.vue?vue&type=template&id=505f2603&scoped=true&"
import script from "./dwv.vue?vue&type=script&lang=js&"
export * from "./dwv.vue?vue&type=script&lang=js&"
import style0 from "./dwv.vue?vue&type=style&index=0&id=505f2603&prod&scoped=true&lang=css&"
import style1 from "./dwv.vue?vue&type=style&index=1&id=505f2603&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505f2603",
  null
  
)

export default component.exports